module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    staticClass: "cb-header__wrap cb-transition__slide",
    attrs: {
      "id": "cb-header-wrap"
    }
  }, [_c('div', {
    staticClass: "cb-header__animate"
  }, [_c('cb-slide-n-fade', [(this.$route.meta.headerLogo && _vm.logo) ? _c('div', {
    staticClass: "cb-header__logo cb-transition__slide"
  }, [_c('img', {
    staticClass: "cb-header__image",
    class: {
      'cb-header__image--xl': _vm.scaleLogo
    },
    attrs: {
      "src": _vm.logo,
      "alt": "logo"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('cb-slide-n-fade', [(!_vm.showReferralSection) ? _c('div', {
    key: "thankyou",
    staticClass: "cb-header__content",
    class: {
      'cb-header__content--fade': _vm.fadeHeaderContent
    }
  }, [(_vm.headerText) ? _c('div', {
    staticClass: "cb-header__heading"
  }, [_vm._v("\n          " + _vm._s(_vm.headerText) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.bodyText) ? _c('div', {
    staticClass: "cb-header__desc"
  }, [_vm._v("\n          " + _vm._s(_vm.bodyText) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.thankYouClose) ? _c('div', {
    staticClass: "cb-header__close"
  }, [_c('button-field', {
    attrs: {
      "custom-class": 'secondary',
      "aria-label": "close checkout",
      "attr": 'cb_close'
    },
    on: {
      "next": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.thankYouClose) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.goto_app && _vm.action_pages_redirect_url) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    staticClass: "cb-section cb-section--nomargin",
    attrs: {
      "role": "navigation"
    },
    on: {
      "click": function($event) {
        _vm.gotoApp()
      }
    }
  }, [_c('div', {
    staticClass: "cb-section__link cb-section__link--ac"
  }, [_vm._v(_vm._s(_vm.goToAppText) + " →")])]) : _vm._e()]) : _c('div', {
    key: "referral",
    staticClass: "cb-header__content",
    class: {
      'cb-header__content--fade': _vm.fadeHeaderContent
    }
  }, [_c('referral-section', [(_vm.thankYouClose) ? _c('div', {
    staticClass: "cb-header__close"
  }, [_c('button-field', {
    attrs: {
      "custom-class": 'secondary sm',
      "aria-label": "close checkout",
      "attr": 'cb_close'
    },
    on: {
      "next": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.thankYouClose) + "\n            ")])], 1) : _vm._e()])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010cd69e"}!./src/components/collections/templates/ThankyouTemplate.html
// module id = 635
// module chunks = 84